<template>
    <div>
        <div>
            <h3 class="font14 nomargin paddingbottom10">
                Gegevens {{ passenger.paxType }} {{ paxIndex + 1 }} /
                {{ paxInfoLength }}

                <div
                    class="floatright font10"
                    v-if="isNaN(passenger.geboortedatum)"
                    style="color:#aaaaaa;"
                >
                    <i>
                        (<span v-if="passenger.maxAge === null"
                            >vanaf {{ passenger.minAge }} jaar vereist</span
                        >
                        <span v-else=""
                            >tussen {{ passenger.minAge }} en
                            {{ passenger.maxAge }} jaar vereist</span
                        >
                        voor
                        <span v-if="paxIndex === 0">de hoofdboeker</span>
                        <span v-else="">{{ passenger.paxType }}</span
                        >)
                    </i>
                </div>

                <span v-if="paxIndex === 0"> <b>(Hoofdboeker)</b><br /> </span>
            </h3>
        </div>

        <div class="clear height5"></div>
      <!-- start -->
        <div class="flexrow">
          <div class="flexbox">
            <div>Voornaam:
            <span class="rood"
            >*
                    <span
                        v-if="
                            (showWarnings &&
                                isEmptyOrNull(passenger.voornaam)) ||
                                (nameWarn &&
                                    paxIndex === 0 &&
                                    isEmptyOrNull(passenger.voornaam))
                        "
                    >We missen een voornaam.</span
                    >
                    <span
                      v-if="
                        (!isEmptyOrNull(passenger.voornaam) && isInvalidName(passenger.voornaam))
                      "
                    >Minstens 2 karakters, cijfers niet toegestaan.</span>

                    <span
                      v-if="
                        (!isEmptyOrNull(passenger.voornaam) && passenger.voornaam.match(/[^\w\s-]/gi))
                      "
                    >Speciale karakters zijn niet toegestaan.</span>

                    <span
                        v-if="
                            !isEmptyOrNull(passenger.voornaam) &&
                                (passenger.voornaam.indexOf(' ') > 0 ||
                                    passenger.voornaam.indexOf('.') > 0 ||
                                    passenger.voornaam.indexOf(',') > 0)
                        "
                    >Alleen eerste voornaam; Geen spatie, komma of punt.
                    </span>
                </span>
            </div>
            <input
                v-model="passenger.voornaam"
                @blur="setUppercaseFirstName"
                :id="'testPaxVoornaam' + paxIndex"
                type="text"
                size="10"
                class="width100 requiredfield"
                placeholder="Vul alleen je eerste voornaam volgens paspoort in"
            />
            <p style="color: #664d03; background-color: #fff3cd; border-color: #ffecb5; padding: 5px; margin-top: 5px;">Voornaam zoals vermeld in het paspoort. Namen na e/v, p/v of w/v N.V.T.</p>

          </div>
          <div class="flexbox">
            <div>
            Achternaam:
            <span class="rood"
            >*
                    <span
                        v-if="
                            showWarnings && isEmptyOrNull(passenger.achternaam)
                        "
                    >We missen een achternaam.</span>

                <span v-if="
                        (!isEmptyOrNull(passenger.achternaam) && passenger.achternaam.match(/[^\w\s-]/gi))
                      ">Speciale karakters zijn niet toegestaan.</span>

                  <span
                        v-if="(!isEmptyOrNull(passenger.achternaam) && isInvalidName(passenger.achternaam))
                      "
                    >Minstens 2 karakters, cijfers niet toegestaan</span>
                </span>
            <span v-if="passenger.geslacht === 'Female'">
                    Voer als achternaam de geboortenaam volgens paspoort in.
                </span>
            </div>
            <input
                v-model="passenger.achternaam"
                @blur="setUppercaseLastName"
                :id="'testPaxAchternaam' + paxIndex"
                type="text"
                size="10"
                class="width100 requiredfield"
                placeholder="Volledige achternaam vanuit het paspoort"
            />
            <p style="color: #664d03; background-color: #fff3cd; border-color: #ffecb5; padding: 5px; margin-top: 5px;">Achternaam zoals vermeldt in het paspoort. Namen na e/v, p/v of w/v N.V.T.</p>

            <p
                v-if="passenger.achternaam && (passenger.achternaam.includes('/') || passenger.achternaam.includes('.') || passenger.achternaam.includes('-'))"
                style="color:red"
            >
              Let op, vul altijd je oorspronkelijke achternaam volgens paspoort in. Reizen met je getrouwde naam of ‘echtgenoot van’ is niet toegestaan.
            </p>
            <p
                v-if="passenger.achternaam && (passenger.achternaam.includes('(') || passenger.achternaam.includes(')') || passenger.achternaam.includes('.'))"
                style="color:red"
            >
              Let op, vul altijd je oorspronkelijke achternaam volgens paspoort in. Speciale tekens zijn niet toegestaan.
            </p>
          </div>
        </div>
      <!-- end row -->
      <!-- start -->
        <div class="flexrow flex3">
          <div class="flexbox">
            <div>
            Geslacht:
            <span class="rood"
            >*
                <span v-if="showWarnings && isEmptyOrNull(passenger.geslacht)"
                >We missen het geslacht.</span
                >
            </span>
            </div>
            <div class="select-drop">
              <select
                  v-model="passenger.geslacht"
                  :id="'testPaxGeslacht' + paxIndex"
                  class="requiredfield"
              >
                <option disabled value="">Maak een keuze</option>
                <option value="Male">Man</option>
                <option value="Female">Vrouw</option>
              </select>
            </div>
          </div>
          <div class="flexbox">
            <div>
            Geboortedatum:
            <span class="rood"
            >*
              <span v-if="rederijNaam === 'AIDA Cruises'">Ga naar stap 1 om je geboortedatum aan te passen.</span>
                    <span
                        v-if="
                            showWarnings &&
                                (passenger.dag === null ||
                                    passenger.maand === null ||
                                    passenger.jaar === null)
                        "
                    >
                        Onjuiste geboortedatum.
                    </span>

                    <span
                        v-if="
                  showWarnings &&
                                !isEmptyOrNull(passenger.geboortedatum) &&
                                ((passenger.minAge !== null &&
                                age(passenger.geboortedatum) <
                                    passenger.minAge ) ||
                                (passenger.maxAge !== null &&
                                age(passenger.geboortedatum) > passenger.maxAge))
                        "
                    >
                        {{ age(passenger.geboortedatum) }} jaar, <br />

                        <span v-if="passenger.maxAge === null">
                            vanaf {{ passenger.minAge }} jaar vereist
                        </span>
                        <span v-else="">
                            tussen {{ passenger.minAge }} en
                            {{ passenger.maxAge }} jaar vereist
                        </span>

                        voor

                        <span v-if="paxIndex === 0">
                            de hoofdboeker.
                        </span>
                        <span v-else=""> {{ passenger.paxType }}. </span>
                    </span>
                </span>
            </div>
            <div class="nextline">
              <div class="floatleft width30">
                <div class="select-drop">
                  <select
                      v-model="passenger.dag"
                      :id="'testPaxGeboorteDag' + paxIndex"
                      class="width100"
                      :disabled="rederijNaam === 'AIDA Cruises'"
                  >
                    <option value="" disabled selected>Dag</option>
                    <option
                        v-for="(day, index) in createDays"
                        :key="'passengerDay' + index"
                        :value="day.number"
                    >{{ day.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="floatleft width30">
                <div class="select-drop">
                  <select
                      v-model="passenger.maand"
                      :id="'testPaxGeboorteMaand' + paxIndex"
                      class="width100"
                      :disabled="rederijNaam === 'AIDA Cruises'"
                  >
                    <option value="" disabled selected>Maand</option>
                    <option
                        v-for="(month, index) in createMonths"
                        :key="'passengerMonth' + index"
                        :value="month.number"
                    >{{ month.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="floatleft width30">
                <div class="select-drop">
                  <select
                      v-model="passenger.jaar"
                      :id="'testPaxGeboorteJaar' + paxIndex"
                      class="width100"
                      :disabled="rederijNaam === 'AIDA Cruises'"
                  >
                    <option value="" disabled selected
                    >Geboortejaar</option
                    >
                    <option
                        v-for="(year, index) in createYears"
                        :key="'passengerYear' + index"
                        :value="year"
                    >{{ year }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="flexbox">
            <div>  Nationaliteit:
              <span class="rood"
              >*
                    <span
                        v-if="
                            showWarnings &&
                                isEmptyOrNull(passenger.nationaliteit)
                        "
                    >
                        Er is geen Nationaliteit gekozen.
                    </span></span></div>
            <div class="select-drop">
              <select
                  v-model="passenger.nationaliteit"
                  :id="'testPaxNationaliteit' + paxIndex"
                  class="width100 requiredfield"
              >
                <option disabled value=""
                >Selecteer nationaliteit</option
                >
                <option
                    v-for="(nationality,
                            index) in nationalities.collection"
                    :key="'passengerNationality' + index"
                    :value="nationality.value"
                >
                  {{ nationality.text }}
                </option>
              </select>
            </div>
            <p
                v-if="
                        passenger.nationaliteit !== '1' &&
                            passenger.nationaliteit !== '2' &&
                            passenger.nationaliteit !== null
                    "
                style="color:red"
            >
              Je hebt geen Nederlandse of Belgische nationaliteit, neem
              even
              <a href="tel:0107200500" style="color:red">contact</a> met
              ons op, we controleren graag of we deze mooie vakantie ook
              voor je kunnen boeken met je huidige nationaliteit.
            </p>
          </div>
        </div>
      <!-- end row -->
      <div v-if="paxIndex === 0">
        <!-- start -->
        <div class="flexrow">
          <div class="flexbox">
            <div>
              Emailadres:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings &&
                                    isEmptyOrNull(passenger.emailadres)) ||
                                    (emailWarn &&
                                        isEmptyOrNull(passenger.emailadres))
                            "
                        >
                            We missen een email adres.
                        </span>

                    <span v-if="(!isEmptyOrNull(passenger.emailadres) && isInvalidEmail(passenger.emailadres))">
                        Dit emailadres is niet geldig.
                    </span>
              </span>
            </div>
            <input
                v-model="passenger.emailadres"
                :id="'testEmailAdres' + paxIndex"
                type="text"
                size="10"
                class="width100 requiredfield"
            />
          </div>
          <div class="flexbox">
            <div>
              Telefoonnummer:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings || emailWarn) &&
                                    isEmptyOrNull(passenger.telefoonnummer)
                            "
                        >
                            We missen een telefoonnummer.
                        </span>
                      <span
                          v-if="
                                (
                                    isInvalidPhoneNumber(passenger.telefoonnummer))
                            "
                      >
                            Zorg ervoor dat je telefoonnnummer voldoet aan de volgende indeling +landnummer gevolgd door je telefoonnummer. Bijvoorbeeld: +31107200500
                        </span>
                    </span>
            </div>
            <input
                v-model="passenger.telefoonnummer"
                :id="'testPaxTelefoonnummer' + paxIndex"
                type="text"
                size="10"
                class="width100 requiredfield"
                value=""
                placeholder="+31107200500"
            />
          </div>
        </div>
        <!-- end row -->
        <!-- start -->
        <div class="flexrow flex3">
          <div class="flexbox">
            <div>
              Postcode:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings &&
                                    isEmptyOrNull(passenger.postcode))
                            "
                        >
                            We missen een postcode
                        </span>
                    </span>
            </div>
            <input
                v-model="passenger.postcode"
                v-on:change="findAddress"
                type="text"

                class="width100 requiredfield"
            />
          </div>
          <div class="flexbox">
            <div>
              Huisnummer:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings || emailWarn) &&
                                    isEmptyOrNull(passenger.huisnummer)
                            "
                        >
                            We missen een huisnummer.
                        </span>
                    </span>
            </div>
            <input
                v-model="passenger.huisnummer"
                v-on:change="findAddress"
                type="text"
                size="10"
                class="width100 requiredfield"
                value=""
            />
          </div>

          <div class="flexbox">
            <div>
              Land:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings &&
                                    isEmptyOrNull(passenger.country))
                            "
                        >
                            We missen een land
                        </span>
                    </span>
            </div>
            <select
                v-model="passenger.country"
                class="width100 requiredfield"
            >
              <option disabled value=""
              >Selecteer Land</option
              >
              <option
                  v-for="(country,
                            index) in countries"
                  :key="'passengerCountry' + index"
                  :value="country.land"
              >
                {{ country.land }}
              </option>
            </select>
          </div>
        </div>
        <!-- end row -->
        <!-- start -->
        <div class="flexrow">
          <div class="flexbox">
            <div>
              Straat:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings &&
                                    isEmptyOrNull(passenger.straat))
                            "
                        >
                            We missen een straat
                        </span>
                    </span>
            </div>
            <input
                v-model="passenger.straat"
                type="text"

                class="width100 requiredfield"
            />
          </div>

          <div class="flexbox">
            <div>
              Woonplaats:
              <span class="rood"
              >*
                        <span
                            v-if="
                                (showWarnings || emailWarn) &&
                                    isEmptyOrNull(passenger.plaatsnaam)
                            "
                        >
                            We missen een plaatsnaam.
                        </span>
                    </span>
            </div>
            <input
                v-model="passenger.plaatsnaam"
                type="text"
                size="10"
                class="width100 requiredfield"
                value=""
            />
          </div>

        </div>
        <!-- end row -->

      </div>




    </div>
</template>

<script>
export default {
    name: 'Passenger',
    props: {
        passenger: Object,
        paxInfoLength: Number,
        paxIndex: Number,
        showWarnings: Boolean,
        nationalities: Object,
        countries: Object,
        rederijNaam: String,
        isEmptyOrNull: Function,
      isInvalidPhoneNumber: Function,
        isInvalidEmail: Function,
        isInvalidName: Function,
        age: Function,
        nameWarn: Boolean,
        emailWarn: Boolean,
    },
    computed: {
        createYears: function() {
            let currentYear = this.moment().year()
            let retYears = []

            let maxDisplayAge = this.passenger.maxAge
            if (this.passenger.maxAge === null) maxDisplayAge = 110

            for (let age = this.passenger.minAge; age <= maxDisplayAge; age++) {
                retYears.push(currentYear - parseInt(age))
            }
            return retYears
        },
        createMonths: function() {
            let retMonths = []

            for (let month = 1; month <= 12; month++) {
                retMonths.push({
                    number: month,
                    name: this.moment()
                        .month(month - 1)
                        .format('MMMM'),
                })
            }
            return retMonths
        },
        createDays: function() {
            let retDays = []

            for (let day = 1; day <= 31; day++) {
                retDays.push({ number: day, name: day })
            }
            return retDays
        },
    },
    data() {
      return {

      }
    },
    methods: {
        setUppercaseFirstName: function() {
            let name = this.passenger.voornaam
            this.passenger.voornaam = name[0].toUpperCase() + name.slice(1)
        },
        setUppercaseLastName: function() {
            let name = this.passenger.achternaam
            this.passenger.achternaam = name[0].toUpperCase() + name.slice(1)
        },

      findAddress: function() {
          let self = this
        self.passenger.action = 'getAdressInfo'
        if(!self.passenger.straat && !self.passenger.plaatsnaam) {
          $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: this.passenger,
            success: function(responseData) {

              if(responseData && responseData.items) {
                self.passenger.straat = responseData.items[0].address.street
                self.passenger.plaatsnaam = responseData.items[0].address.city
              }
            }
          })
        }
      },
    },

}
</script>

<style lang="scss" scoped>
.flexrow {
 display: flex;
  width:100%;
  .flexbox {
    width:50%;
    padding-right: 10px;
    box-sizing: border-box;
    display: flex;
    flex-flow:column;
    .nextline {
      .select-drop {
        margin-right:10px;
      }
    }
  }
  margin-bottom:10px;
}

.flex3 .flexbox {
  width: calc(100% / 3);
}
@media screen and (max-width: 1024px) {
  .flexrow
  {
    .flexbox {
      width: 100% !important;
    }
    flex-flow: column;
    margin-top:5px;

  }
    .width20,
    .width40 {
        width: 100%;
    }
    .nextline {
        width: 100% !important;
        float: left;
        padding: 0;
    }
    .nextline .width20 {
        width: calc((100% / 3) - 10px) !important;
        margin: 0 5px;
    }
    .nextline:first-child {
        margin-left: 0;
    }
    .nextline:nth-last-child {
        margin-right: 0;
    }
    .select-drop select {
        width: 100%;
        margin-top: 5px;
        margin-bottom: 5px;
    }
}
</style>
